<template>
  <v-card>
    <v-snackbar v-model="snackbar" :color="snackbar_color">{{
      snackbar_text
    }}</v-snackbar>

    <v-toolbar dense dark color="indigo">
      <v-toolbar-title>Articoli nei Lotti</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :disabled="items_articolo_lotti.length === 0"
            @click="saveBack"
            light
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="success"> mdi-check </v-icon>
          </v-btn>
        </template>
        <span> Salva </span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="ml-5" icon small v-bind="attrs" v-on="on">
            <v-icon color="white"> mdi-information-variant-circle </v-icon>
          </v-btn>
        </template>
        <span>
          Lotto, sottolotto / seriale e data scadenza sono ND se l'articolo non ha la gestione lotto o la gestione seriale. Impostare da Articolo / Specifiche.
        </span>
      </v-tooltip>

      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="goBack" light small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span> Chiudi </span>
      </v-tooltip>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col cols="12" sm="6" md="4" align="left">
          <h2>Totale articoli da prelevare: {{ this.NUM_TOT_ARTICOLI }}.</h2>
        </v-col>
        <v-col cols="12" sm="6" md="4" align="center">
          <v-text-field
            style="width: 180px"
            type="number"
            class="my-0 py-0"
            hide-details
            label="Impostare nuova quantità"
            :min="0"
            outlined
            :max="this.NUM_TOT_ARTICOLI"
            v-model="quantita_selezionata"
            @input="gestisciQuantitàPrelevate()"
            @focus="$event.target.select()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" align="right">
          <h2>Quantità prelevata {{ this.quantita_selezionata }}</h2>
        </v-col>
      </v-row>
    </v-container>
    <v-data-table
      :headers="headers_articolo_lotti"
      :items="
        lotto_unico == -1
          ? items_articolo_lotti
          : items_articolo_lotti.filter((elem) => elem.id_lotto == lotto_unico)
      "
      class="elevation-3"
    >
      <!-- Spazio del Cod. Lotto -->
      <template v-slot:[`item.cod_lotto`]="{ item }">
        {{
          item.cod_lotto != null && item.cod_lotto != ""
            ? item.cod_lotto
            : "N/D"
        }}
      </template>

      <template v-slot:[`item.selezione`]="{ item }">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              @click="num_articoli_da_lotto(item)"
            >
              <v-icon color="success"
                >mdi-check-outline &nbsp;&nbsp;&nbsp;&nbsp;</v-icon
              >
            </v-btn>
          </template>
          <span>Selezione numero pezzi articolo da Lotto</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.data_scadenza_lotto`]="{ item }">
        {{ formatData(item.data_scadenza_lotto, "strict") }}
      </template>

      <template v-slot:[`item.check`]="{ item }">
        <v-checkbox
          :disabled="
            (item.check != true && disabled_check == true) ||
            item.qta_disponibile <= 0
          "
          style="margin-left: 50px"
          v-model="item.check"
          @change="_check(item)"
        ></v-checkbox>
      </template>
    </v-data-table>

    <!-- Dialog di conferma scelta lotto successivo -->
    <v-dialog persistent v-model="dialog_avviso_lotto_precedente" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Conferma Lotto
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Attenzione! Hai ancora disponibilità in un lotto precedente.
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn @click="dialog_avviso_lotto_precedente = false" small>
                  <span style="color: #4caf50; font-size: 15px">Ho capito</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Gestione dialog picking 
        <v-dialog v-model="dialog_picking" max-width="30%" persistent >
            <v-card>
                <v-toolbar
                        class="white--text"
                        color="blue"
                        dense
                        style="position: sticky; top: 0px; z-index: 1"
                        >
                        <v-toolbar-title> Selezione quantità articoli da lotto </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            class="red--text"
                            @click="dialog_picking = false"
                            color="blue-grey lighten-5"
                            small
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-row>
                        <v-col cols="12" sm="6" md="4" />
                        <v-col cols="12" sm="6" md="4" class="d-flex justify-center">
                            <v-text-field
                                v-model="num_articoli_selezionati"
                                label="Numero Articoli"
                                hint="Numero di articoli del lotto da prelevare"
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4"/> 
                        <v-col cols="12" sm="6" md="12">
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="save_picking"
                            >
                            Save
                            </v-btn>
                        </v-col>                            
                    </v-row>

            </v-card>
        </v-dialog>
        -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
// import axios from "axios";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  components: {
    SnackbarQV,
  },
  props: {
    DA: String,
    COD_ARTICOLO: String,
    CAMBIO_STATO: Number,
    GESTIONE_LOTTO: Number,
    NUM_TOT_ARTICOLI: Number,
    ID_ARTICOLO: Number,
    lotto_unico: Number,
    ARRAY_ID_DOC_DETTAGLIO: Array,
    QTA_CONTENITORE: Number,
    ID_CONTENITORE: Number,
    ID_COMMESSA: Number,
  },
  data() {
    return {
      snackbar: false,
      snackbar_color: "",
      snackbar_text: "",
      dialog_picking: false,
      dialog_avviso_lotto_precedente: false,
      num_articoli_selezionati: 0,
      quantita_selezionata: 0,
      quantita_da_prelevare: 0,
      TRIGGER: 0,
      checked: true,
      disabled_check: false,

      items_articolo_lotti: [], //Array (Matrice contenente  Lotto, cod_Articolo, giacenza e quantità prelevate in funzione della selezione dei check)
      array_picking_lotti_articolo: [],
      headers_articolo_lotti: [
        { text: "Lotto", value: "cod_lotto" },
        { text: "Data Scadenza Lotto", value: "data_scadenza_lotto" },
        { text: "Sottolotto", value: "numero_seriale" },
        { text: "Cod. Articolo", value: "cod_articolo" },
        { text: "Giacenza", value: "giacenza" },
        /*{ text: "Qta Prelevata", value: "qta_prelevata" },*/
        { text: "Qta Disponibile", value: "qta_disponibile" },
        { text: "Prelievo", align: "center", sortable: false, value: "check" },
      ],

      item_articolo_lotto: {
        cod_lotto: "",
        cod_articolo: "",
        pmu: "",
        num_pezzi: "",
      },
      item_articolo_selezionato: { lotto: "", cod_articolo: "", quantita: "" },
    };
  },

  computed: {},
  mounted() {
    this.quantita_da_prelevare = this.NUM_TOT_ARTICOLI;
    this.getArticoliLottoPicking();
  },
  watch: {
    COD_ARTICOLO: {
      immediate: true,
      handler() {
        this.quantita_selezionata = 0;
        this.quantita_da_prelevare = this.NUM_TOT_ARTICOLI;
        this.getArticoliLottoPicking();
      },
    },

    CAMBIO_STATO: {
      immediate: true,
      handler() {
        this.quantita_da_prelevare = this.NUM_TOT_ARTICOLI;
        this.getArticoliLottoPicking();
      },
    },
    TRIGGER: {
      immediate: true,
      handler() {
        this.gestisciQuantitàPrelevate();
      },
    },
  },
  methods: {
    _check(item) {
      this.disabled_check = !this.disabled_check;
      this.items_articolo_lotti.forEach((e, i) => {
        if (item.check == false) {
          this.quantita_selezionata = 0;
          return;
        }

        /* Il criterio di paragone dei lotti di materia prima per Insit
         * è il numero_seriale, per altri è il cod_lotto; faccio in modo
         * di capire dove mi trovo e decido cosa usare come criterio di
         * paragone. */
        let criterio_paragone = "cod_lotto";
        if (
          item.cod_lotto == null &&
          item.numero_seriale != null &&
          item.numero_seriale != ""
        ) {
          criterio_paragone = "numero_seriale";
        }

        console.log(this.lotto_unico);

        /* Se mi accorgo di aver selezionato una riga
         * che non è la prima, faccio scattare un avviso. */
        if (
          e[criterio_paragone] == item[criterio_paragone] &&
          i != 0 &&
          item.check == true &&
          this.items_articolo_lotti.filter(
            (elem, j) => j < i && elem.qta_disponibile > 0
          ).length > 0 &&
          e.id_lotto != this.lotto_unico
        ) {
          this.dialog_avviso_lotto_precedente = true;
          this.quantita_selezionata =
            this.NUM_TOT_ARTICOLI < e.qta_disponibile
              ? this.NUM_TOT_ARTICOLI
              : e.qta_disponibile;
        } else {
          if (
            e[criterio_paragone] == item[criterio_paragone] &&
            item.check == true
          ) {
            this.quantita_selezionata =
              this.NUM_TOT_ARTICOLI < e.qta_disponibile
                ? this.NUM_TOT_ARTICOLI
                : e.qta_disponibile;
          }
        }
      });

      // this.TRIGGER = Math.round(Math.random() * 100);
    },
    formatData(arg_data, arg_tipo = "full") {
      if (arg_data == null || arg_data == "") {
        return "N/D";
      } else {
        if (arg_tipo == "full") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          strRes += arg_data.substr(11, 8);
          return strRes;
        } else if (arg_tipo == "strict") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          return strRes;
        }
      }
    },
    getArticoliLottoPicking() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getpickingarticolo",
          id_articolo: this.ID_ARTICOLO,
          qta_prelievo: this.quantita_da_prelevare,
          id_contenitore: this.ID_CONTENITORE,
          qta_contenitore: this.QTA_CONTENITORE,
          token: localStorage.getItem("user_token"),
        },
      };
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.items_articolo_lotti = [];
          res.data.forEach((elem, i) => {
            if (i === 0) {
              if (elem.qta_disponibile > 0) {
                elem.check = false;
                this.items_articolo_lotti.push(elem);
                this.quantita_selezionata =
                  this.quantita_da_prelevare > elem.qta_disponibile
                    ? elem.qta_disponibile != null
                      ? elem.qta_disponibile
                      : 0
                    : this.quantita_da_prelevare;
              } else {
                elem.check = false;
                this.items_articolo_lotti.push(elem);
              }
            }
            if (i != 0) {
              elem.check = false;
              this.items_articolo_lotti.push(elem);
            }
          });

          /* Se c'è un primo lotto selezionabile con disponibilità inferiore
           * a quella che mi serve, prendo la sua quantità, altrimenti se ha
           * una disponibilità maggiore di quello che mi serve, seleziono solo
           * la quantità di materiale che mi serve. */
          if (
            this.items_articolo_lotti.filter(
              (e) =>
                e.qta_disponibile > 0 &&
                (this.lotto_unico == e.id_lotto || this.lotto_unico == -1)
            ).length > 0
          ) {
            const ref_tmp = this.items_articolo_lotti.filter(
              (e) =>
                e.qta_disponibile > 0 &&
                (this.lotto_unico == e.id_lotto || this.lotto_unico == -1)
            )[0];

            if (this.NUM_TOT_ARTICOLI < ref_tmp.qta_disponibile) {
              this.quantita_selezionata = this.NUM_TOT_ARTICOLI;
            } else {
              this.quantita_selezionata = ref_tmp.qta_disponibile;
            }

            // Seleziono la riga dell'impegno.
            ref_tmp.check = true;

            // Eseguo le operazioni contestuali alla selezione automatica.
            this._check(ref_tmp);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
    // gestisciQuantitàPrelevate() {
    //   let qta_selezionata = 0;
    //   let quantita_rimanente = this.quantita_da_prelevare;
    //   this.items_articolo_lotti.forEach((elem) => {
    //     if (elem.check == 1 && quantita_rimanente > 0) {
    //       if (quantita_rimanente >= elem.giacenza) {
    //         quantita_rimanente = quantita_rimanente - elem.giacenza;
    //         elem.qta_prelevata = elem.giacenza;

    //         qta_selezionata = qta_selezionata + elem.qta_prelevata;
    //       } else {
    //         //rimanente < giacenza

    //         elem.qta_prelevata = quantita_rimanente;
    //         qta_selezionata = qta_selezionata + elem.qta_prelevata;
    //         quantita_rimanente = 0;
    //       }
    //     } else {
    //       elem.qta_prelevata = 0;
    //     }
    //   });
    //   this.quantita_selezionata = qta_selezionata;
    // },
    gestisciQuantitàPrelevate() {
      let qta_selezionata = 0;
      let quantita_rimanente = this.quantita_selezionata;

      this.items_articolo_lotti.forEach((elem) => {
        if (elem.check == true && quantita_rimanente > 0) {
          if (quantita_rimanente >= elem.giacenza) {
            quantita_rimanente = quantita_rimanente - elem.giacenza;
            elem.qta_prelevata = elem.giacenza;

            qta_selezionata = qta_selezionata + elem.qta_prelevata;
          } else {
            //rimanente < giacenza

            elem.qta_prelevata = quantita_rimanente;
            qta_selezionata = qta_selezionata + elem.qta_prelevata;
            quantita_rimanente = 0;
          }
        } else {
          elem.qta_prelevata = 0;
        }
      });
      this.quantita_selezionata = parseFloat(qta_selezionata);
    },
    goBack() {
      this.$emit("go_back");
      this.disabled_check = false;
    },
    setpicking() {
      return new Promise((resolve, reject) => {
        let request = {
          controller: "Magazzino",
          method: "PUT",
          richiesta: {
            action: "setpicking",
            lista_id_documento_dettaglio: this.ARRAY_ID_DOC_DETTAGLIO,
            array_picking: this.array_picking_lotti_articolo,
            id_contenitore: this.ID_CONTENITORE,
            qta_contenitore: this.QTA_CONTENITORE,
            token: localStorage.getItem("user_token"),
          },
        };
        this.$store
          .dispatch("api", request)
          .then((res) => {
            resolve(res);
            return;
          })
          .catch((e) => {
            reject(e);
            console.error(e);
          });
      });
    },

    // async saveBack() {
    //   this.array_picking_lotti_articolo = [];
    //   this.items_articolo_lotti.forEach((elem) => {
    //     if (elem.qta_prelevata > 0) {
    //       this.array_picking_lotti_articolo.push(elem);
    //     }
    //   });
    //   if (this.DA == "Packaging") {
    //     await this.setpicking();
    //     this.$emit("imballo");
    //   }
    //   if (this.DA == "DistintaBase") {
    //     this.$emit("prelievo", this.array_picking_lotti_articolo);
    //   }
    //   /*
    //             if (await this.setpicking() == 'OK'){
    //                 this.snackbar_text = "Articoli prelevati correttamente.";
    //                 this.snackbar_color = "Success";
    //                 this.snackbar = true;

    //                 this.$emit("imballo");
    //             }else{
    //                 this.snackbar_text = "Errore nel prelievo degli articoli.";
    //                 this.snackbar_color = "error";
    //                 this.snackbar = true;
    //             }
    //             */
    // },

    saveBack() {
      console.log("entrato save back");
      // Controllo commentato su richiesta di Tartuflanghe per voce di Elsa.
      /*if (this.NUM_TOT_ARTICOLI < this.quantita_selezionata) {
        this.$refs.SnackbarQV.print(
          "orange",
          "La quantità da impegnare non deve essere superiore al totale degli articoli da prelevare."
        );

        return;
      }*/

      this.items_articolo_lotti.forEach((e) => {
        if (e.check == true) {
          const obj_tmp = Object.assign({}, e);
          obj_tmp.gestione_lotto = this.GESTIONE_LOTTO;
          console.log(JSON.stringify(obj_tmp));
          this.$emit("prelievo_singolo", obj_tmp, this.quantita_selezionata);
        }
      });
    },
  },
};
</script>
